import { TranslationKey } from './translation/TranslationKey';

import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity, forCreate, forDelete, forUpdate } from './common/entity';
import { t } from './translation/Translator';

export enum EntityType {
  lot = 'lot',
  bin = 'bin',
  pmd = 'pmd',
  serial = 'serial',
  task = 'task',
  order = 'order',
  product = 'product',
  stockLocation = 'stockLocation',
  container = 'container',
  user = 'user',
  kit = 'kit',
  productTransaction = 'productTransaction',
  asset = 'asset',
}

enum CommentValidationError {}

export class Comment extends CompanyEntity {
  entityId!: string;
  parentId?: string;
  type!: EntityType;
  content!: string;
  userId!: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }

  forUpdate(): UpdateCommentInput {
    return UpdateCommentInput.from(this, UpdateCommentInput);
  }

  forDelete(): DeleteCommentInput {
    return DeleteCommentInput.from(this, DeleteCommentInput);
  }

  validate() {
    return this.validateEntity(Object.getOwnPropertyNames(this) as (keyof Comment)[], (field: keyof Comment) => {
      return null;
    });
  }
}

export class CreateCommentInput extends forCreate(Comment) {}

export class UpdateCommentInput extends forUpdate(Comment) {}

export class DeleteCommentInput extends forDelete(Comment) {}

export function entityTypeToString(type: EntityType): string {
  switch (type) {
    case EntityType.lot:
      return t(TranslationKey.lot).singular.label;
    case EntityType.bin:
      return t(TranslationKey.bin).singular.label;
    case EntityType.pmd:
      return t(TranslationKey.productMasterData).singular.label;
    case EntityType.serial:
      return t(TranslationKey.serial).singular.label;
    case EntityType.task:
      return t(TranslationKey.task).singular.label;
    case EntityType.order:
      return t(TranslationKey.order).singular.label;
    case EntityType.product:
      return t(TranslationKey.product).singular.label;
    case EntityType.stockLocation:
      return t(TranslationKey.stockLocation).singular.label;
    case EntityType.container:
      return t(TranslationKey.container).singular.label;
    case EntityType.user:
      return t(TranslationKey.user).singular.label;
    case EntityType.kit:
      return t(TranslationKey.kit).singular.label;
    case EntityType.productTransaction:
      return t(TranslationKey.productTransaction).singular.label;
    case EntityType.asset:
      return t(TranslationKey.asset).singular.label;
  }
}
